<template>
  <div class="col-xs-12 invests-calculator">
    <radio-button :choices="currencies" 
      class="col-md-6 col-xs-12"
      v-on:change="updateCurrency"
      label="Валюта"
      name="currency">
    </radio-button>
    <currency-input
      class="col-md-6 col-xs-12"
      v-model="calcState.startAmount"
      label="Стартовый капитал"
      v-bind:currency="calcState.currency"
      v-on:update:value="updateNumber('startAmount', $event)"
    ></currency-input>
    <number-input
      class="col-md-6 col-xs-12"
      v-model="calcState.numPeriods"
      label="Число периодов"
      v-on:update:value="updateNumber('numPeriods', $event)"
    ></number-input>
    <currency-input
      class="col-md-6 col-xs-12"
      v-model="calcState.contribution"
      label="Пополнение за период"
      v-bind:currency="calcState.currency"
      v-on:update:value="updateNumber('contribution', $event)"
    ></currency-input>
    <number-input
      class="col-md-6 col-xs-12"
      v-model="calcState.returnRate"
      label="Доходность, %"
      v-on:update:value="updateNumber('returnRate', $event)"
    ></number-input>

    <div class="col-xs-12">
      <c-button
        v-on:click="buttonClicked">Рассчитать доход</c-button>
    </div>  
    <div class="spacer-little"></div>
    <div
      class="col-xs-12" 
      v-if="results.length">
      <div class="invests__summary text-center">
        По истечению срока, баланс будет составлять <p class="invests__summary--number">{{ totalAmount | number }}</p>
      </div>
      <div>
        <bar-chart
          :chartData="barData"
        ></bar-chart>
        <pie-chart
          v-bind:style="{ height: '250px' }"
          :chartData="pieData"
        ></pie-chart>
      </div>
      <div class="spacer-little"></div>
      <div v-for="result in results">
        <result-card
          class="col-xs-12" 
          :item="result">
        </result-card>
      </div>
    </div>  
  </div>
</template>


<script>
import {formatNumber} from '../../filters/index.js';
import RadioButtonComponent 
  from '../input/radiobutton.vue';
import NumberComponent from '../input/number.vue';
import CurrencyComponent from '../input/currency.vue';
import ButtonComponent from '../input/button.vue';
import ResultCardComponent from './_result_card.vue';
import BarChart from './_barchart.vue';
import PieChart from './_piechart.vue';


export default {
  data: function () {
    let calcState = {
      currency: 'RUB',
      startAmount: 10000,
      numPeriods: 12,
      periodType: 'MONTH',
      returnRate: 9,
      contribution: 0,
    }, results = [], totalAmount = null;
    
    return {calcState, results};
  },
  computed: {
    currencies: function () {
      let res = [{
        value: 'RUB', label: "Руб", id: 1,
          checked: this.calcState.currency === 'RUB'
        }, {
        value: 'USD', label: "USD", id: 2,
          checked: this.calcState.currency === 'USD'
       }];
       return res;
    },
    resultsAmount: function () {
      let res = this.results.map((i) => i.amount);
      return res;
    },
    resultsYear: function () {
      let res = this.results.map((i) => i.period);
      return res;
    },
    printTable: function () {
      // console.log(this.calcState, 'printTable');
      return this.calcState;
    },
    barData: function () {
      return {
        labels: this.resultsYear,
        datasets: [
          {
            label: 'Баланс',
            backgroundColor: '#20a7e2',
            data: this.resultsAmount,
          }
        ]
      };
    },
    pieData: function () {
      const lastIndex = this.results.length;
      if (!lastIndex) {
        return;
      }

      const item = this.results[lastIndex - 1];
      return {
        labels: ['Стартовый капитал', 'Внесено', 
                 'Полученная прибыль'],
        datasets: [{
          backgroundColor: ['#20a7e2', '#e96945', '#41b883'],
          data: [item.startAmount.toFixed(2),
                 item.totalContribution.toFixed(2),
                 item.totalReturn.toFixed(2)]
          }]
      };
    }
  },
  components: {
    'radio-button': RadioButtonComponent,
    'number-input': NumberComponent,
    'currency-input': CurrencyComponent,
    'c-button': ButtonComponent,
    'result-card': ResultCardComponent,
    'bar-chart': BarChart,
    'pie-chart': PieChart
  },
  filters: {
    number: formatNumber
  },
  methods: {
    updateCurrency: function (value) {
      this.calcState.currency = value;
    },
    updateNumber: function (field, value) {
      value = +value || 0;
      this.calcState[field] = value;
    },
    buttonClicked: function () {
      let {numPeriods, startAmount, contribution,
           returnRate, currency} = this.calcState,
        amount = startAmount,
        totalContribution = 0,
        currentReturn = 0,
        totalReturn = 0;
      const year = 2018;

      this.results = [];
      this.totalAmount = null;

      for (let i = 0; i < numPeriods; i++) {
        amount += contribution;
        currentReturn = amount * returnRate / 100;

        totalContribution += contribution;
        totalReturn += currentReturn;
        amount += currentReturn;

        let periodResult = {
          num: i + 1,
          period: year + i,
          startAmount: startAmount,
          amount: amount.toFixed(2),
          contribution: contribution,
          currentReturn: currentReturn,
          totalContribution: totalContribution,
          totalReturn: totalReturn,
          currency: currency
        };
        this.results.push(periodResult);
      }
      this.totalAmount = amount;
    }
  }
};
</script>
